import { BaseEntity } from '../../models';
import { clienteGrupoEconomicoAtivo } from './cliente-grupo-economico-situacao';
import { ClienteGrupoEconomicoRepresentante } from './representante';

export class ClienteGrupoEconomico implements BaseEntity {
    id: number;
    idEmpresa: number;
    codigo: string;
    nome: string;
    situacao: number;
    representantes: ClienteGrupoEconomicoRepresentante[];

    constructor() {
        this.situacao = clienteGrupoEconomicoAtivo.id;
        this.representantes = [];
    }
}
